import styled, { keyframes } from 'styled-components';
import { palette } from '../../theme/colors';
import { SearchBarBase } from '../SearchBarBase/SearchBarBase';

export const TopControlContainer = styled.div`
  position: absolute;
  top: 6.06rem;
  z-index: 99;
  width: 100%;
  padding: 0 1rem;
  display: flex;
  flex-direction: column;
  gap: 20px;

  // enable children to be be styled as touch-transparent
  pointer-events: none;
  & * {
    pointer-events: auto;
  }
`;

const enterAnimation = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const DragInfoBanner = styled.div`
  background-color: ${palette.honeyYellow};
  color: black;
  padding: 20px;
  border-radius: 12px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;

  animation: ${enterAnimation} 0.3s ease-in-out forwards;

  &,
  & * {
    pointer-events: none;
  }
`;

export const SSearchWithButton = styled.div`
  display: flex;
`;

export const SSearchBarBase = styled(SearchBarBase)`
  width: calc(100% - 51px - 1rem);
  margin-right: 1rem;
`;

export const SCenterMarkerWrapper = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
  pointer-events: none;
`;

export const SLocationButton = styled.button`
  cursor: pointer;
  width: 51px;
  border: 1px solid ${palette.queenBlue};
  border-radius: 12px;
  background-color: ${({ theme }) => theme.palette.background.searchBar};
  display: flex;
  align-items: center;
  justify-content: center;
`;
